let map = {};
let list = [];

export default {
  map,
  list,
  reset: function () {
    for (let key in map) {
      delete map[key];
    }
    list.splice(0);
  },
  set: function (name, x, y) {
    let location = {name, x, y};
    map[name] = location;
    list.push(location)
  },
  get: function (name) {
    return map[name];
  },
  distance: function (a, b) {
    if (typeof(a) === 'object') {
      a = a.name
    }
    if (typeof(b) === 'object') {
      b = b.name
    }
    let [lA, lB] = [map[a], map[b]];
    return lA && lB ? Math.sqrt(Math.pow(lA.x - lB.x, 2) + Math.pow(lA.y - lB.y, 2)) : -1;
  }
}
